import { render, staticRenderFns } from "./ManagerCabinet.vue?vue&type=template&id=10481d82&scoped=true"
import script from "./ManagerCabinet.vue?vue&type=script&lang=js"
export * from "./ManagerCabinet.vue?vue&type=script&lang=js"
import style0 from "./ManagerCabinet.vue?vue&type=style&index=0&id=10481d82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10481d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
